import { useEffect, useState } from "react";
import { getPermissionsList } from "../../helpers/getPermission";
import List from "./List";
import DataLoading from "../../components/DataLoading";

const Logs = () => {
  const [userId, setuserId] = useState<any>(null);
  const getLogs = async (id: string) => {
    setuserId(id);
  };
  const getTokenData = async () => {
    let token = await getPermissionsList();
    if (token?.login_user?.profile?._id) {
      getLogs(token?.login_user?.profile?._id);
    }
  };
  useEffect(() => {
    getTokenData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div style={{ padding: "14px", width: "100%", height: "100%" }}>
      {userId ? <List id={userId} /> : <DataLoading />}
    </div>
  );
};

export default Logs;
